import React, { useEffect } from "react";
import { navigate } from "@reach/router";
import StandardTemplate from "../../../templates/standard_template/standard_template";
import FixAndFlipPage1 from "../../../components/loan_tools/fix_and_flip/fix_and_flip_page1";
import FixAndFlipPrintHeader from "../../../components/loan_tools/fix_and_flip/fix_and_flip_print_header";
import "../../../components/loan_tools/fix_and_flip/css/fix_and_flip.scss";
import { useDocument } from "../../../components/loan_tools/loan_tool";

export default function FixAndFlipPage1Route() {
  const [loanDoc, , { documentId }, actions] = useDocument();

  useEffect(() => {
    const borrowers = loanDoc && loanDoc.applicant && loanDoc.applicant.borrowers;
    const lastName = (borrowers && borrowers[0] && borrowers[0].last_name) || "";
    const title = lastName ? `${lastName} Fix & Flip Calc` : "Fix & Flip Calc";
    actions.setPageTitleOverride(title);
    return () => actions.setPageTitleOverride(null);
  }, [loanDoc]);

  function goToPage(n) {
    navigate(`/loan-tool/${documentId}/fix-and-flip/page-${n}`);
  }

  function printAll() {
    window.open(`/loan-tool/${documentId}/fix-and-flip/print-all`, "_blank");
  }

  // Back to the loan file — SAVE first so Fix & Flip entries are never lost when
  // the LO leaves the form (it does not auto-save). Returns to the Summary Sheet,
  // which works whether the form was opened in the same tab or a new one.
  async function backToLoan() {
    try {
      await actions.saveDocument();
    } catch (e) {
      // non-fatal; values remain on screen
    }
    navigate(`/loan-tool/${documentId}/summary-sheet`);
  }

  return (
    <StandardTemplate className="fix-and-flip-template">
      <FixAndFlipPrintHeader pageTitle="Page 1 of 4 — Borrower, Property & Loan Officer Info" />
      <div className="fix-and-flip">
        <div className="ff-header">
          <div className="ff-header-title">
            <div>
              <h1>Fix and Flip Estimator</h1>
              <h2>Page 1 of 4 — Borrower, Property &amp; Loan Officer Info</h2>
            </div>
          </div>
          <div className="ff-header-actions no-print">
            <div className="ff-page-nav">
              <button className="button ff-back-button" onClick={backToLoan}>‹ Back</button>
              <span className="ff-page-tab active">Page 1</span>
              <span className="ff-page-tab" onClick={() => goToPage(2)}>Page 2</span>
              <span className="ff-page-tab" onClick={() => goToPage(3)}>Page 3</span>
              <span className="ff-page-tab" onClick={() => goToPage(4)}>Page 4</span>
              <button className="button" onClick={() => window.print()}>Print Page</button>
              <button className="button" onClick={printAll}>Print All</button>
            </div>
          </div>
        </div>

        <FixAndFlipPage1 />
      </div>
    </StandardTemplate>
  );
}
